"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/shipping/v1/cms_service.proto (package spwn.shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSShippingService = void 0;
const cms_service_pb_1 = require("./cms_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.shipping.v1.CMSShippingService
 */
exports.CMSShippingService = {
    typeName: "spwn.shipping.v1.CMSShippingService",
    methods: {
        /**
         * 発送する
         *
         * @generated from rpc spwn.shipping.v1.CMSShippingService.CompleteShipping
         */
        completeShipping: {
            name: "CompleteShipping",
            I: cms_service_pb_1.CMSShippingServiceCompleteShippingRequest,
            O: cms_service_pb_1.CMSShippingServiceCompleteShippingResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=cms_service_connect.js.map